import React, { useMemo, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Button, RegWallContainer } from '@surfline/quiver-react';
import {
  capitalizeFirstLetter,
  getMeterRemaining,
  trackClickedSubscribeCTA,
  trackEvent,
  SL_FREE_TRIAL,
  TABLET_LARGE_WIDTH,
} from '@surfline/web-common';

import config from '../../../../config';
import { SERVED_POPUP, CLICKED_POPUP, RATE_LIMITING } from '../../../../common/constants';
import {
  usePromotionEntitlementsSelector,
  useUserDetailsSelector,
} from '../../../../selectors/user';

const MeterPremiumPaywall = () => {
  const meterRemaining = useSelector(getMeterRemaining);
  const { firstName } = useUserDetailsSelector();
  const promotionEntitlements = usePromotionEntitlementsSelector();

  const isFreeTrialEligible = useMemo(
    () => promotionEntitlements.includes(SL_FREE_TRIAL),
    [promotionEntitlements],
  );

  const ctaButtonText = isFreeTrialEligible ? 'START FREE TRIAL' : 'GO PREMIUM';

  useEffect(() => {
    trackEvent(SERVED_POPUP, {
      popupName: 'Rate Limiting Paywall',
      category: RATE_LIMITING,
      platform: 'web',
      isMobileView: window.innerWidth <= TABLET_LARGE_WIDTH,
    });
  }, []);

  const onClickCTA = useCallback(() => {
    trackEvent(CLICKED_POPUP, {
      action: 'Clicked CTA',
      category: 'Rate Limiting Paywall',
    });

    trackClickedSubscribeCTA({
      location: 'Rate Limiting Paywall',
      checksRemaining: meterRemaining,
      platform: 'web',
    });
    setTimeout(() => window.location.assign(config.funnelUrl), 300);
  }, [meterRemaining]);

  const headerText = `${
    firstName ? `${capitalizeFirstLetter(firstName)}, you've` : "You've"
  } run out of Surf Checks this week`;

  const NUM_OF_CHECKS = 3;

  const subHeaderText = `You'll get ${NUM_OF_CHECKS} new surf checks on Monday.`;

  return meterRemaining !== null ? (
    <div className="sl-meter-premium-paywall__container">
      <RegWallContainer>
        <div className="sl-meter-premium-paywall__content">
          <div className="sl-meter-premium-paywall__box-header">
            <p className="sl-meter-premium-paywall__count-message">You have</p>
            <div className="sl-meter-premium-paywall__count">
              <span className="sl-meter-premium-paywall__count--text">0 Surf Checks</span>
            </div>
            <p className="sl-meter-premium-paywall__count-message">left</p>
          </div>
          <h5 className="sl-meter-premium-paywall__title">{headerText}</h5>
          <p className="sl-meter-premium-paywall__subtitle">{subHeaderText}</p>
          <p className="sl-meter-premium-paywall__subtitle-two">
            A Premium account will get you unlimited access to <br />
            ad-free cams, long-range forecasts and more!
          </p>
          <Button className="sl-meter-premium-paywall__actions" onClick={onClickCTA}>
            {ctaButtonText}
          </Button>
          <div className="sl-meter-premium-paywall__actions--mobile">
            <Button onClick={onClickCTA}>
              <p>{ctaButtonText}</p>
            </Button>
          </div>
        </div>
      </RegWallContainer>
    </div>
  ) : null;
};

export default MeterPremiumPaywall;
